// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"1b9456fdb207f697b29f","339":"38a10b83c24bdd589cca"}[chunkId] + ".js";
};